import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Logout from '@mui/icons-material/Logout';
import useUserAction from "../../hooks/user/useUserAction";
import {EXHIBITION} from "../../locales/components/namespaces";
import {useTranslation} from "react-i18next";
import ListItemText from "@mui/material/ListItemText";
import {ListItem, ListItemButton} from "@mui/material";
import Divider from "@mui/material/Divider";
import PrintBadgeSelectSize from "../printBadgeButton/printBadgeSelectSize";

export default function AccountMenu() {
    const {t} = useTranslation(EXHIBITION)
    const [anchorEl, setAnchorEl] = React.useState(null)
    const open = Boolean(anchorEl)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const {userLogout} = useUserAction()
    return (
        <React.Fragment>
            <Box sx={{display: 'flex', alignItems: 'center', textAlign: 'center'}}>
                <Tooltip title={t("Account settings")}>
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ml: 2}}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <Avatar sx={{width: 32, height: 32}}/>
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{horizontal: 'right', vertical: 'top'}}
                anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
            >
                {/*<ListItem>*/}
                {/*    <ListItemIcon sx={{minWidth: '78px'}}>*/}
                {/*        <PrintBadgeSelectSize/>*/}
                {/*    </ListItemIcon>*/}
                {/*    <ListItemText*/}
                {/*        primary={t("Print paper size")}*/}
                {/*    />*/}
                {/*</ListItem>*/}
                {/*<Divider/>*/}
                <ListItemButton onClick={userLogout}>
                    <ListItemIcon sx={{minWidth: '78px'}}>
                        <Logout fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText
                        primary={t('Logout')}
                    />
                </ListItemButton>
            </Menu>
        </React.Fragment>
    )
}
